import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  message!: any;

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    console.log(this.message)
  }

  dismiss(){
    this.modalService.hideErrorModal();
  }

}
